import { FC } from 'react';
// components
import AccessDenied from 'components/AccessDenied';
// helper, interfaces, context
import { isAdminOrStaff } from 'lib/helper';
import { ChildrenType } from 'interfaces';
import { useAuthContext } from 'contexts/AuthContext';

export const AdminOrStaffGuard: FC<ChildrenType> = ({ children }) => {
  const { userRoles } = useAuthContext();

  const isAdminAndStaffUser = isAdminOrStaff(userRoles);

  return <>{isAdminAndStaffUser ? children : <AccessDenied />}</>;
};
